module.exports = __webpack_public_path__ + "img/popUp_list_img.427921a.webp";